import { ReactElement } from "react"

import { Button, Text } from "ui-kit/components-branded/index"
import { Icon } from "components"
import { isBrowser } from "utils/infrastructure/ssg-utils"

interface Props {
    instruction?: ReactElement
    instructionUrl?: string
    settingsUrl?: string
    onClose?: () => void
}

export const ScreenShareSettingContent = (props: Props) => {
    function open(url?: string) {
        if (!(url && isBrowser())) return
        window.open(url)
        props.onClose?.()
    }

    return (
        <div className="m-2">
            <div>
                <div>
                    <Text isAccent>Как дать доступ к&nbsp;экрану</Text>
                </div>
                <div className="pt-3 pb-3">
                    <Text>
                        {props.instruction}
                        <br />
                        <a
                            href={props.instructionUrl}
                            target="_blank"
                            className="is-block text-decoration-none"
                            rel="noreferrer"
                        >
                            <span className="is-underlined">Подробнее</span>{" "}
                            <Icon type="arrow-short-right" size={16} />
                        </a>
                    </Text>
                </div>
            </div>
            <div className="mt-3">
                {(props.settingsUrl && (
                    <Button isFullwidth onClick={() => open(props.settingsUrl)}>
                        Открыть настройки
                    </Button>
                )) || (
                    <Button isFullwidth onClick={props.onClose}>
                        Понятно
                    </Button>
                )}
            </div>
        </div>
    )
}
